import React, { useState } from 'react';
import img from '../images/Login/img.png';
import { toast } from 'react-toastify';
// import google from '../images/Login/google.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { setUser } from '../redux/Slices/UserSlice';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { encrypt } from '../crypto'
import { jwtDecode } from 'jwt-decode';


function Login() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '679657473604-m4l1k8245b000kuknvsqssai83rqi1ck.apps.googleusercontent.com';
    const dispatch = useDispatch();
    const [rememberMe, setRememberMe] = useState(false);
    const [loginMode, setLoginMode] = useState('otp'); // password | otp
    const [mobileNumber, setMobileNumber] = useState('');
    const [loginOtp, setLoginOtp] = useState('');
    const [loginOtpSession, setLoginOtpSession] = useState('');
    const [loginOtpStatus, setLoginOtpStatus] = useState('');

    React.useEffect(() => {
        const remembered = localStorage.getItem('rememberedIdentifier');
        if (remembered) {
            setEmail(remembered);
            setRememberMe(true);
        }
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword((prevState) => !prevState);
    };


    // Navigate to Signup Page
    const signuppage = () => {
        navigate('/signup');
    };

    const handleSendLoginOtp = async () => {
        setLoginOtpStatus('');
        if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
            setError('Enter a valid 10-digit mobile number');
            return;
        }

        const trySendOtp = async (channel) => {
            const res = await axios.post(`${apiBaseUrl}/user/sendLoginOtp/BLACKBATON_2526`, {
                mobile: mobileNumber,
                channel
            });
            const sessionId = res?.data?.sessionId;
            if (!sessionId) {
                throw new Error(res?.data?.error || `Failed to send OTP via ${channel.toUpperCase()}`);
            }
            return { sessionId, channel };
        };

        try {
            let sent;
            try {
                sent = await trySendOtp('sms');
            } catch (smsErr) {
                sent = await trySendOtp('whatsapp');
            }
            setLoginOtpSession(sent.sessionId);
            setLoginOtpStatus(`OTP sent via ${sent.channel === 'sms' ? 'SMS' : 'WhatsApp'}`);
            setError('');
        } catch (err) {
            console.error('OTP send error:', err);
            setError('OTP service is not reachable right now. Please try again in a moment.');
        }
    };

    const handleVerifyLoginOtp = async () => {
        if (!loginOtpSession) {
            setError('Please request OTP first');
            return;
        }
        if (!loginOtp || loginOtp.length !== 6) {
            setError('Enter 6-digit OTP');
            return;
        }

        try {
            const response = await axios.post(`${apiBaseUrl}/user/verifyLoginOtp/BLACKBATON_2526`, {
                sessionId: loginOtpSession,
                otp: loginOtp
            });

            if (response.data.success) {
                const userData = response.data.user;

                localStorage.setItem('loginId', userData.id);
                localStorage.setItem('i_a', encrypt(String(userData.isAdmin)));
                localStorage.setItem('loginName', userData.full_name || '');
                localStorage.setItem('loginEmail', userData.email || '');
                localStorage.setItem('loginMobile', userData.mobile || '');
                localStorage.setItem('LedCode', userData.id);

                if (rememberMe) {
                    localStorage.setItem('rememberedIdentifier', mobileNumber);
                } else {
                    localStorage.removeItem('rememberedIdentifier');
                }

                dispatch(setUser({
                    id: userData.id,
                    rememberMe,
                    isAdmin: encrypt(String(userData.isAdmin))
                }));

                navigate('/');
            } else {
                setError(response.data.error || 'Invalid OTP');
            }
        } catch (err) {
            console.error('OTP verify error:', err);
            setError(err.response?.data?.error || 'Failed to verify OTP');
        }
    };

    // Handle Login
    // const handleLogin = async () => {
    //     try {
    //         if (!email || !password) {
    //             setError('Please enter both email and password');
    //             return;
    //         }

    //         const apiUrl = `${apiBaseUrl}/user/login/BLACKBATON_2526?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`;

    //         const response = await axios.get(apiUrl);

    //         if (response.data.length > 0) {
    //             const userData = response.data[0];

    //             // Store user id in localStorage
    //             localStorage.setItem('loginId', userData.id);
    //             localStorage.setItem('i_a', encrypt(String(userData.isAdmin)));


    //             // Store user name in localStorage
    //             localStorage.setItem('loginName', userData.full_name);
    //             localStorage.setItem('loginEmail', userData.email);
    //             localStorage.setItem('LedCode', userData.id);
    //             //  localStorage.setItem('password', userData.password);



    //             // Dispatch user data to Redux
    //             dispatch(setUser({ id: userData.id, rememberMe, isAdmin: encrypt(String(userData.isAdmin)) }));

    //             // Navigate to the home page
    //             navigate('/');
    //         } else {
    //             setError('Invalid email or password');
    //         }
    //     } catch (err) {
    //         console.error('Login error:', err);
    //         setError('An error occurred while logging in');
    //     }
    // };

    const handleLogin = async () => {
        try {
            if (!email || !password) {
                setError('Please enter both email/mobile and password');
                return;
            }

            // Determine if input is email or mobile number
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const mobilePattern = /^\d{10}$/;

            let isInput = '';

            if (emailPattern.test(email)) {
                isInput = 'email';
            } else if (mobilePattern.test(email)) {
                isInput = 'mobile';
            } else {
                setError('Please enter a valid email or 10-digit mobile number');
                return;
            }

            // Create request payload
            const loginData = {
                identifier: email, // This can be email or mobile
                password: password,
                type: isInput
            };

            // Use POST request instead of GET with query parameters
            const response = await axios.post(
                `${apiBaseUrl}/user/login/BLACKBATON_2526`,
                loginData
            );

            if (response.data.success) {
                const userData = response.data.user;

                // Store user data in localStorage
                localStorage.setItem('loginId', userData.id);
                localStorage.setItem('i_a', encrypt(String(userData.isAdmin)));
                localStorage.setItem('loginName', userData.full_name);
                localStorage.setItem('loginEmail', userData.email || '');
                localStorage.setItem('loginMobile', userData.mobile || '');
                localStorage.setItem('LedCode', userData.id);

                if (rememberMe) {
                    localStorage.setItem('rememberedIdentifier', email);
                } else {
                    localStorage.removeItem('rememberedIdentifier');
                }

                // Dispatch user data to Redux
                dispatch(setUser({
                    id: userData.id,
                    rememberMe,
                    isAdmin: encrypt(String(userData.isAdmin))
                }));

                // Navigate to the home page
                navigate('/');
            } else {
                setError(response.data.error || 'Invalid credentials');
            }
        } catch (err) {
            console.error('Login error:', err);
            setError(err.response?.data?.error || 'An error occurred while logging in');
        }
    };

    // const handleGoogleLogin = async (credentialResponse) => {

    //     try {
    //         const { credential } = credentialResponse;

    //         // Send token to backend
    //         const response = await axios.post(
    //             `${apiBaseUrl}/user/googleLogin/BLACKBATON_2526`,
    //             { token: credential }
    //         );

    //         //('Login Successful:', response.data);

    //         const userData = response.data;


    //         // Store user id in localStorage
    //         localStorage.setItem('loginId', userData.id);
    //         localStorage.setItem('i_a', encrypt(String(userData.isAdmin)));


    //         // Store user name in localStorage
    //         localStorage.setItem('loginName', userData.full_name);
    //         localStorage.setItem('loginEmail', userData.email);
    //         localStorage.setItem('LedCode', userData.id);
    //         //  localStorage.setItem('password', userData.password);

    //         dispatch(setUser({ id: userData.id, rememberMe, isAdmin: encrypt(String(userData.isAdmin)) }));

    //         toast.info('Google Sign-In successful!');
    //         navigate('/');
    //     } catch (error) {
    //         console.error('Google Login Error:', error.response?.data || error);
    //         toast.info('Google Sign-In failed.');
    //     }
    // };


    const handleGoogleLogin = async (credentialResponse) => {
        try {
            const { credential } = credentialResponse;

            const decoded = jwtDecode(credential);
            const { email, name } = decoded;

            // ?? Call signup (acts like upsert)
            const signupRes = await fetch(`${apiBaseUrl}/user/googleSignUp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, full_name: name })
            });

            const signupData = await signupRes.json();

            // console.log(signupData, 'signupData');


            //  If user is newly created OR already exists ? proceed to login
            if (signupData.success) {

                const loginRes = await axios.post(
                    `${apiBaseUrl}/user/googleLogin/BLACKBATON_2526`,
                    { token: credential }
                );

                const userData = loginRes.data;

                // Store user info
                localStorage.setItem('loginId', userData.id);
                localStorage.setItem('i_a', encrypt(String(userData.isAdmin)));
                localStorage.setItem('loginName', userData.full_name);
                localStorage.setItem('loginEmail', userData.email);
                localStorage.setItem('LedCode', userData.id);

                dispatch(setUser({
                    id: userData.id,
                    rememberMe,
                    isAdmin: encrypt(String(userData.isAdmin))
                }));

                toast.info('Google Sign-In successful!');
                navigate('/');

            } else {
                // only when backend truly fails
                toast.info(signupData.error || signupData.message || 'Google sign-up failed');
            }

        } catch (err) {
            console.error('Google Signup/Login Error:', err);
            toast.info('Google Sign-In Failed');
        }
    };




    const forgotpasspage = () => {
        navigate('/forgotpass')
    }

    return (
        <GoogleOAuthProvider clientId={googleClientId}>
            <div className="min-h-screen flex flex-row bg-white relative overflow-hidden">
                <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-gray-200 blur-3xl" />
                <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-gray-100 blur-3xl" />
                {/* Left Section */}
                <div className="w-1/2 lg:flex hidden justify-center items-center relative z-10">
                    <div className='h-[680px] w-[80%] rounded-[32px] border border-gray-200 bg-white p-4 shadow-[0_20px_60px_rgba(15,23,42,0.12)]'>
                        <img src={img} alt="img" className='w-full h-full rounded-[24px] object-cover' />
                    </div>
                </div>

                {/* Right Section */}
                <div className="lg:w-1/2 w-full flex justify-center items-center flex-col lg:gap-8 gap-4 py-6 lg:py-0 relative z-10">
                    <div className='flex flex-col gap-2 lg:px-0 px-5 w-full max-w-[430px]'>
                        <span className='lg:text-5xl text-3xl font-[500] font-notoSerif text-black'>Welcome Back</span>
                        <span className='lg:text-base text-sm font-[400] font-montserrat text-[#3D3D3D]'>
                            Enter your email and password to access your<br /> account
                        </span>
                    </div>

                    <div className='flex flex-col gap-6 px-5 w-full max-w-[430px] bg-white rounded-[28px] p-5 lg:p-6 border border-gray-200 shadow-[0_16px_50px_rgba(15,23,42,0.12)]'>
                        <div>
                            <button
                                className='text-xs font-bold uppercase tracking-widest underline text-gray-600'
                                onClick={() => { setLoginMode(loginMode === 'password' ? 'otp' : 'password'); setError(''); }}
                                type="button"
                            >
                                {loginMode === 'password' ? 'Use Mobile OTP' : 'Use Password Login'}
                            </button>
                        </div>

                        {loginMode === 'password' ? (
                            <div className='flex flex-col gap-4'>
                                {/* Email Input */}
                                <div className='flex flex-col gap-2 text-left'>
                                    <span className='text-base font-[500] font-montserrat'>Email / Mobile</span>
                                    <input
                                        type="text"
                                        className='w-full h-[48px] rounded-[12px] px-3 bg-[#F3F4F6] border border-gray-200'
                                        placeholder='Enter your email or mobile number'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>

                                {/* Password Input */}
                                <div className='flex flex-col gap-2 text-left'>
                                    <span className='text-base font-[500] font-montserrat'>Password</span>
                                    <div className='relative'>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            className='w-full h-[48px] rounded-[12px] px-3 bg-[#F3F4F6] border border-gray-200'
                                            placeholder='Enter your password'
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <div
                                            className='absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer'
                                            onClick={togglePasswordVisibility}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </div>
                                    </div>

                                    <div className='flex justify-between items-center'>
                                        <div className='flex flex-row gap-1 items-center'>
                                            <input
                                                type="checkbox"
                                                className='cursor-pointer'
                                                checked={rememberMe}
                                                onChange={() => setRememberMe(!rememberMe)}
                                            />
                                            <span className='font-[500] font-montserrat text-sm'>Remember me</span>
                                        </div>

                                        <span className='font-[400] text-sm font-montserrat cursor-pointer' onClick={forgotpasspage}>Forgot Password?</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='flex flex-col gap-4'>
                                <div className='flex flex-col gap-2 text-left'>
                                    <span className='text-base font-[500] font-montserrat'>Mobile Number</span>
                                    <input
                                        type="tel"
                                        className='w-full h-[48px] rounded-[12px] px-3 bg-[#F3F4F6] border border-gray-200'
                                        placeholder='Enter 10-digit mobile number'
                                        value={mobileNumber}
                                        onChange={(e) => setMobileNumber(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className='w-full h-[44px] rounded-[12px] bg-black text-white font-[600] font-montserrat'
                                        onClick={handleSendLoginOtp}
                                    >
                                        Send OTP
                                    </button>
                                    {loginOtpStatus && <span className='text-green-600 text-sm font-semibold'>{loginOtpStatus}</span>}
                                </div>
                                {loginOtpStatus && (
                                    <div className='flex flex-col gap-2 text-left'>
                                        <span className='text-base font-[500] font-montserrat'>Enter OTP</span>
                                        <input
                                            type="text"
                                            className='w-full h-[48px] rounded-[12px] px-3 bg-[#F3F4F6] border border-gray-200'
                                            placeholder='6-digit OTP'
                                            value={loginOtp}
                                            onChange={(e) => setLoginOtp(e.target.value)}
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Error Message */}
                        {error && <div className="text-red-500">{error}</div>}

                        {/* Buttons */}
                        <div className='flex flex-col gap-2'>
                            {/* Sign In Button */}
                            {loginMode === 'password' ? (
                                <button
                                    className='w-full h-[48px] rounded-[12px] bg-black flex justify-center items-center font-[600] font-montserrat text-base text-white'
                                    onClick={handleLogin}
                                >
                                    Sign In
                                </button>
                            ) : (
                                loginOtpStatus && (
                                    <button
                                        className='w-full h-[48px] rounded-[12px] bg-black flex justify-center items-center font-[600] font-montserrat text-base text-white'
                                        onClick={handleVerifyLoginOtp}
                                    >
                                        Verify & Sign In
                                    </button>
                                )
                            )}

                            {/* Sign In with Google */}
                            <div className='w-full h-[48px]  flex flex-row gap-2 justify-center items-center'>
                                <div className='w-full h-full'>
                                    <GoogleLogin
                                        onSuccess={handleGoogleLogin}
                                        onError={() => console.error('Google Sign-In Failed')}
                                    />
                                </div>
                            </div>

                            {/* Sign Up Link */}
                            <br />
                            <span className='text-sm font-[600] font-montserrat text-[#49475A]'>
                                Not a Member?{' '}
                                <span className='text-black underline cursor-pointer' onClick={signuppage}>
                                    Register Here
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </GoogleOAuthProvider>
    );
}

export default Login;




